import { Component, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { InwardStatus } from 'src/app/Enums/inwardEnum';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { TrackerOmnitureService } from 'src/app/shared/services/tracker-omniture.service';

@Component({
  selector: 'app-upload-challan',
  templateUrl: './upload-challan.component.html',
  styleUrls: ['./upload-challan.component.less']
})
export class UploadChallanComponent implements OnInit {
  selectedRequest: any;
  pdfSrc = "";
  url = "";
  type = "";
  name = "";
  size: number;
  InwardStatus = InwardStatus;
  service_URL: any;
  request: any;
  load: boolean = false;

  private unsubscribe$ = new Subject<void>();

  constructor(
    private modalService: BsModalService,
    private _dataContextService: DataContextService,
    private toast: ToastrService,
    private trackeromnitureservice:TrackerOmnitureService
  ) {
    this.service_URL = ConstantsService;
  }

  ngOnInit(): void {
    var username = localStorage.getItem('email');
    username = username.split('@')[0];
    this.trackeromnitureservice.trackPageloadData('upload-challan',username);
    this.trackeromnitureservice.trackPage("pageView");
    // console.log(this.selectedRequest);
  }

  Cancel() {
    this.modalService.hide(1);
    $('body').removeClass('modal-open');
  }

  UpdateStatus(){
    let p = {
      statusId: InwardStatus.ChallanUploaded,
      requestId: this.selectedRequest.requestId,
      updatedBy : localStorage.getItem('email'),
      CollectedBy: this.selectedRequest.collectedBy,
      CollectedByName: this.selectedRequest.collectedByName
    }

    let auditData = [];

    let statusChangeAudit: AuditData = new AuditData();
    statusChangeAudit.changedAttribute = "Status";
    statusChangeAudit.oldValue = "Collect Materials";
    statusChangeAudit.newValue = "Challan Uploaded"

    auditData.push(statusChangeAudit);
    
    this._dataContextService.postDatawithValues<any>(this.service_URL.InwardDetails.UpdateStatus, p)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res == 1) {
          this.toast.success("Challan Successfully Uploaded");
        }
        else {
          this.toast.error("Something went wrong");
        }
      },
      (error) => {
        console.log(error);
        this.toast.error("Status cannot be updated");
      },
      () => {
        //Saving Data in Audit Trail
      let auditParams = {
        actionPerformed : "Status Change",
        actionPerformedOn : "Inward",
        changedBy : localStorage.getItem('email'),
        dateChanged : new Date(),
        primaryKey : this.selectedRequest.serialNumber,
        generalInformation : [],
        material : [],
        statusChange: auditData
      };

        this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail,auditParams)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res) => {
          // console.log(res);
        },
        (err) => {
          console.log(err);
        },
        () => {
          this.modalService.hide(1);
          window.location.reload();
        })
      })
  }
  
  GetById(id){
    this._dataContextService.get<any>(this.service_URL.InwardDetails.ViewRequest + '/' + id)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe(res => {
      this.request = res;
    }
    )
  }

  Submit() {
    var file;

    if(this.type === 'application/pdf'){
      file = this.pdfSrc.split(",");
    }
    else{
      file = this.url.split(",");
    }

    let params = {
      requestId : this.selectedRequest.requestId,
      fileBase64 : file[1],
      fileExtension : ""
    }

    this.GetById(this.selectedRequest.requestId);
    var uploadUrl = this.service_URL.ChallanUpload.upload;
    this._dataContextService.postDatawithValues<any>(uploadUrl,params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        // console.log(res);
        if (res) {
          this.UpdateStatus();
        }
        else {
          this.toast.error("Something went wrong");
        }
      },
      (error) => {
        console.log(error);
        this.toast.error("Something went wrong");
      },
      () => {
        this.toast.success("Challan Successfully Uploaded");
      })

      //this.UpdateStatus();
  }

  base(event) {
    this.type = event.target.files[0].type;
    this.name = event.target.files[0].name;
    this.size = event.target.files[0].size;
    this.load = true;

    // console.log(this.size);
    var mb = ((this.size / 1024) / 1024);
    if (Math.ceil(mb) > 4.5) {
      this.toast.error("File size is more than 4.5 MB !");
      this.load = false;
    }
    else {
      if (
        this.type === 'image/png' ||
        this.type === 'image/jpg' ||
        this.type === 'image/jpeg'
      ) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.url = reader.result.toString();
          this.load = false;
          // console.log(this.url)
        };
      }
      else if (this.type === 'application/pdf') {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.pdfSrc = reader.result.toString();
          this.load = false;
        };
      }
      else {
        this.toast.error("Please Check File Type !");
        this.load = false;
      }
    }
    // console.log(this.url);
  }

}
